// extracted by mini-css-extract-plugin
module.exports = {"blogSection":"BlogSection_blogSection__YQ8N2"};